export default "2000d662d5ad6f28.svg"